import { DashboardContainer } from '@forwardflow/components/Dashboard'
import { PhoneNumberManager } from '@forwardflow/features'

export const PhoneNumberManagementPage = () => {
   return (
      <DashboardContainer>
         <PhoneNumberManager />
      </DashboardContainer>
   )
}
